/*
 UI COMPONENT: Slider in Infotainment Cards
 ---------------------------------------------------
 Stimulus API in HTML
 ---------------------------------------------------
 data-action="slider#prev"
 data-action="slider#next"
 */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slides', 'slide', 'prev', 'next', 'bullets']
  static values = {
    imagesDisplay: { type: Number, default: 2 }
  }
  imagesLength
  imageWidth
  scrollIndex = 0
  scroller
  buttons = null

  connect() {
    const images = this.slideTargets
    this.imagesLength = images.length
    this.imageWidth = images[0].clientWidth
    this.scroller = this.slidesTarget
    this.scroller.addEventListener('scroll', (event) => this.#scrollHandler(event))

    if(this.hasBulletsTarget) {
      this.#createSliderNav(this.imagesLength)
    }

    this.#reset()
  }

  prev() {
    this.scrollIndex = Math.max(this.scrollIndex - this.imagesDisplayValue, 0)
    this.#scroll()
  }

  next() {
    this.scrollIndex = Math.min(this.scrollIndex + this.imagesDisplayValue, this.imagesLength - this.imagesDisplayValue)
    this.#scroll()
  }

  #scroll() {
    this.scroller.scrollTo({
      left: this.scrollIndex * this.imageWidth,
      behavior: 'smooth'
    })
    this.#updateButtonState()
  }

  #scrollHandler(event) {
    this.scrollIndex = Math.round(this.scroller.scrollLeft / this.imageWidth)
    this.#updateButtonState()
  }

  #updateButtonState() {
    this.prevTarget.disabled = this.scrollIndex === 0
    this.nextTarget.disabled = this.scrollIndex >= this.imagesLength - this.imagesDisplayValue

    if(this.hasBulletsTarget) {
      this.buttons.forEach((button, index) => button.toggleAttribute('active', index === this.scrollIndex))
    }
  }

  #reset() {
    this.scroller.scrollTo({
      left: 0,
    })
    this.#updateButtonState()
  }

  #buttonHandler(button, index) {
    button.index = index
    button.addEventListener('click', () => {
      this.scrollIndex = button.index
      this.#scroll()
      this.#updateButtonState()
    })
  }

  #createButton(label, active=false) {
    const button = document.createElement('button')
    if (active) button.setAttribute('active', '')

    const span = document.createElement('span')
    span.classList.add('sr-only')
    span.textContent = label
    button.appendChild(span)

    return button;
  }

  #createSliderNav(count=1) {
    let index = 0;
    while (index < count) {
      const button = this.#createButton(index, index === 0)
      this.bulletsTarget.appendChild(button)
      this.#buttonHandler(button, index)
      index++
    }
    this.buttons = this.bulletsTarget.querySelectorAll('button')
  }
}
